// extracted by mini-css-extract-plugin
export default {"card":"CustomCard_card__Z-t+f"};